"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const lab_1 = require("@material-ui/lab");
const core_1 = require("@material-ui/core");
const moment_1 = __importDefault(require("moment"));
const Divider_1 = __importDefault(require("@material-ui/core/Divider"));
const DialogContent_1 = __importDefault(require("@material-ui/core/DialogContent/DialogContent"));
const react_redux_1 = require("react-redux");
const ratingIcon_1 = __importDefault(require("../../../components/ratingIcon/ratingIcon"));
require("./reviews.scss");
const CloseIcon_1 = __importDefault(require("../../../../../svgIcons/CloseIcon"));
const common_1 = require("../../../../../utils/common");
const Reviews = (props) => {
    const { open = false, cancelable, className, user } = props;
    const [modal, setModal] = react_1.useState(open);
    const toggle = () => setModal(!modal);
    const reviews = user.reviews.map((val, key) => {
        let caseType = "";
        let url = "";
        if (val.hash_string) {
            if (val.appearance_type === "Deposition") {
                caseType = "Deposition";
            }
            else {
                caseType = "Appearance";
            }
            url = `#/case?id=${val.hash_string}`;
        }
        else if (val.case_type === 1) {
            caseType = "Court Reporting";
            url = `#/court-report?id=${val.case_id}`;
        }
        else if (val.case_type === 2) {
            caseType = "Interpreting";
            url = `#/tr-case?id=${val.case_id}`;
        }
        else if (val.case_type === 3) {
            caseType = "Freelance";
            url = `#/fatt-case?id=${val.case_id}`;
        }
        return (react_1.default.createElement("div", { key: key, className: 'review-wrapper' },
            react_1.default.createElement("div", { className: 'review-head' },
                react_1.default.createElement("div", { className: 'review-name' }, val.name),
                react_1.default.createElement("div", { className: 'review-date' }, moment_1.default(val.created_at).format('MMM DD, YYYY').toUpperCase())),
            react_1.default.createElement("div", { className: 'review-rating' },
                react_1.default.createElement(lab_1.Rating, { name: "read-only", defaultValue: val.rating, precision: 0.5, size: "large", IconContainerComponent: (e) => {
                        return (react_1.default.createElement(ratingIcon_1.default, { props: e, rate: val.rating }));
                    }, readOnly: true })),
            val.comment && react_1.default.createElement("div", { className: "review-comment" }, common_1.reReplaceChars(val.comment).split('\n').map((item, i) => react_1.default.createElement("p", { style: { margin: 0 }, key: i }, item))),
            react_1.default.createElement("div", { className: "review-case-info" },
                "For this ",
                react_1.default.createElement("a", { href: url, target: "blank" }, caseType))));
    });
    return (react_1.default.createElement(react_1.Fragment, null,
        react_1.default.createElement(core_1.Dialog, { className: `${className} user-reviews`, open: modal, onClose: (cancelable === null || cancelable === void 0 ? void 0 : cancelable.action) || toggle, fullWidth: true, maxWidth: 'sm' },
            react_1.default.createElement("div", { className: 'reviews-header' },
                react_1.default.createElement(CloseIcon_1.default, { onClick: cancelable === null || cancelable === void 0 ? void 0 : cancelable.action, className: 'close-icon' }),
                react_1.default.createElement("div", { className: "review-title" }, "All Reviews"),
                react_1.default.createElement("div", { className: 'rating-box-wrapper' },
                    react_1.default.createElement("div", { className: "rating-box" },
                        react_1.default.createElement(lab_1.Rating, { name: "read-only", defaultValue: user.rate, precision: 0.5, size: "large", IconContainerComponent: (e) => {
                                return (react_1.default.createElement(ratingIcon_1.default, { props: e, rate: user.rate }));
                            }, readOnly: true }),
                        react_1.default.createElement("div", { className: "profile-rating-tot-num" }, user.rate)),
                    react_1.default.createElement("div", { className: "out-of-review" },
                        "Out of ",
                        user.ratesCount,
                        " reviews"))),
            react_1.default.createElement(Divider_1.default, null),
            react_1.default.createElement(DialogContent_1.default, { className: 'reviews-body' }, reviews))));
};
const mapStateToProps = (state) => {
    const { user } = state;
    return {
        user
    };
};
const mapDispatchToProps = () => {
    return {};
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(Reviews);
